import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as RadLocationInterlockRelationActions from './rad-interlock-relation.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';


@Injectable({
  providedIn: 'root'
})
export class RadLocationInterlockRelationStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new RadLocationInterlockRelationActions.RadLocationInterlockRelationRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RADINTERLOCKRELATION, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new RadLocationInterlockRelationActions.RadLocationInterlockRelationCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new RadLocationInterlockRelationActions.RadLocationInterlockRelationUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new RadLocationInterlockRelationActions.RadLocationInterlockRelationDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new RadLocationInterlockRelationActions.RadLocationInterlockRelationRefresh());
      }
    });

  }
}
